import React from "react";
import { Modal } from "antd";
import { CircleLoader } from "react-spinners";
import Cancel from "../../assets/cancel.svg";

interface Props {
  visible: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel?: string;
  loading?: boolean;
  danger?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

// Shared confirmation step for the actions that send real email or change a
// record's state irreversibly (submit, approve, cancel, test send).
const ConfirmModal = ({
  visible,
  title,
  message,
  confirmLabel = "Confirm",
  loading,
  danger,
  onConfirm,
  onClose,
}: Props) => (
  <Modal
    open={visible}
    width={520}
    closable={!loading}
    footer={null}
    onCancel={loading ? undefined : onClose}
    className="flex justify-center items-center">
    <div className="flex justify-center items-center">
      <img src={Cancel} alt="" />
    </div>

    <h1 className="text-center font-bold text-[#040821] text-[18px] mt-2">
      {title}
    </h1>

    <div className="text-center text-[14px] font-normal mt-4 text-gray-700">
      {message}
    </div>

    <div className="flex gap-4 justify-center items-center mt-6">
      <button
        onClick={onClose}
        disabled={loading}
        className="px-6 py-2.5 border border-gray-200 rounded-lg text-[14px] hover:bg-gray-50 disabled:opacity-60">
        Cancel
      </button>
      <button
        onClick={onConfirm}
        disabled={loading}
        className={`px-6 py-2.5 rounded-lg text-[14px] font-semibold text-white flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed ${
          danger ? "bg-[#A10909] hover:bg-[#8a0808]" : "bg-[#0979A1] hover:bg-[#076a8a]"
        }`}>
        {loading ? (
          <CircleLoader color="#ffffff" loading size={18} />
        ) : (
          confirmLabel
        )}
      </button>
    </div>
  </Modal>
);

export default ConfirmModal;
